module.exports = __webpack_public_path__ + "static/DSC_9375_2-bd065310f8360db1bcbe57b9e02d212e.jpg";